import { useApplicationModals } from "app/common/hooks";
import { Button } from "app/components/atoms/button";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { ModalMolecule } from "app/components/molecules/modal";
import LogoSL from "img/sl-logo-fit.PNG";
import { standardDate, standardDay } from "lib/str";
import { Fragment, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { filter as _filter } from "underscore";

function ViewInvoiceModal({ onSuccess = () => {} }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("invoice.view");
  if (payload?.data?.length > 0) {
    console.log("payload: ", payload);
    console.log("data: ", payload.data);
  }
  const invoice = payload?.data;

  const localHelpers = {
    subtotal: (customerId) => {
      return _filter(invoice?.orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return salesOrder?.OrderItems.map(
            (orderDetail) =>
              orderDetail.qty * orderDetail.unit_price +
              orderDetail.variants
                .map((variant) => +variant.price)
                .reduce((partialSum, a) => partialSum + a, 0) *
                orderDetail.qty
          ).reduce((partialSum, a) => partialSum + a, 0);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    shipmentCost: (customerId) => {
      return _filter(invoice?.orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return Number(salesOrder.delivery_fee);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    shipmentCostDiscount: (customerId) => {
      return _filter(invoice?.orders, {
        customer_id: customerId,
        invoice_id: invoice?.id,
      })
        .map((salesOrder) => {
          return Number(salesOrder.delivery_fee_discount);
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    total: (customerId) => {
      return (
        +localHelpers.subtotal(customerId) +
        +localHelpers.shipmentCost(customerId) -
        +localHelpers.shipmentCostDiscount(customerId)
      );
    },
    payment: (payments) => {
      var total = 0;
      payments?.map((payment, key) => (total += Number(payment.total_payment)));
      return total;
    },
  };

  const handleClose = () => closeModal("invoice.view");
  const handleSuccess = () => {
    closeModal("invoice.view");
    onSuccess();
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <ModalMolecule
      show={showStates["invoice.view"]}
      title="View Invoice"
      onClose={handleClose}
      size="xl"
    >
      <div
        ref={componentRef}
        className="space-y-1 text-sm border border-gray-100 shadow-xl print:shadow-none print:border-none"
      >
        <div>
          <div className="w-full bg-white flex justify-between px-8 py-4">
            <div>
              <h1 className="text-4xl font-bold text-black">Invoice</h1>
              <p className="text-sm font-medium text-yellow-500">
                {invoice?.inv_code}
              </p>
            </div>
            <img alt="Logo SL Kitchen" src={LogoSL} className="w-24"></img>
          </div>
          <div className="px-8 py-4 flex justify-between">
            <div>
              <p className="text-lg font-bold">{invoice?.customerName}</p>
              <p className="text-sm font-medium text-gray-500">
                {invoice?.customerPhone}
              </p>
            </div>
            <div className="">
              <Typography.Date date={invoice?.invoiceDate}></Typography.Date>
            </div>
          </div>
        </div>
        <div className="px-8 py-4">
          <Table.Wrapper asIndex={false}>
            <Table.Header>
              <Table.HeaderRow>
                <Table.Heading>Order</Table.Heading>
                <Table.Heading className="text-right">Qty</Table.Heading>
                <Table.Heading className="text-right">
                  Harga Satuan
                </Table.Heading>
                <Table.Heading className="text-right">Subtotal</Table.Heading>
                {/* <Table.Heading className="text-right">Ongkir</Table.Heading> */}
              </Table.HeaderRow>
            </Table.Header>
            <Table.Body>
              {/* {_filter(salesOrders, {
                            customer_id: values.customerId,
                          })?.map((salesOrder, key) => ( */}
              {invoice?.orders?.map((salesOrder, key) => (
                <Fragment key={key}>
                  <Table.BodyRow>
                    <Table.Cell size="sm" fontWeight="semibold">
                      {salesOrder.order_code}
                    </Table.Cell>
                    <Table.Cell size="sm"></Table.Cell>
                    <Table.Cell size="sm"></Table.Cell>
                    <Table.Cell size="sm"></Table.Cell>
                    {/* <Table.Cell size="sm" background={100} className="text-right">
                    <Typography.Currency number={salesOrder.delivery_fee} />
                    {" - "}
                    <Typography.Currency
                      number={salesOrder.delivery_fee_discount}
                    />
                  </Table.Cell> */}
                  </Table.BodyRow>
                  {salesOrder.OrderItems.map((orderItem, nestedKey) => (
                    <Fragment key={nestedKey}>
                      <Table.BodyRow>
                        <Table.Cell size="sm">
                          <span className="ml-5">
                            {orderItem.Product.ProductCategory.name}
                            {": "}
                            {orderItem.Product.name}
                          </span>
                        </Table.Cell>
                        <Table.Cell size="sm" className="text-right">
                          {orderItem.qty}
                        </Table.Cell>
                        <Table.Cell size="sm" className="text-right">
                          <Typography.Currency number={orderItem.unit_price} />
                        </Table.Cell>
                        <Table.Cell size="sm" className="text-right">
                          <Typography.Currency
                            number={+orderItem.qty * +orderItem.unit_price}
                          />
                        </Table.Cell>
                      </Table.BodyRow>
                      {orderItem.variants.map((item, nestedNestedKey) => (
                        <Table.BodyRow key={nestedNestedKey}>
                          <Table.Cell size="sm" className="pl-11">
                            {item.name}
                          </Table.Cell>
                          <Table.Cell size="sm" className="text-right">
                            {orderItem.qty}
                          </Table.Cell>
                          <Table.Cell size="sm" className="text-right">
                            <Typography.Currency number={item.price} />
                          </Table.Cell>
                          <Table.Cell className="text-right">
                            <Typography.Currency
                              number={item.price * orderItem.qty}
                            />
                          </Table.Cell>
                        </Table.BodyRow>
                      ))}
                    </Fragment>
                  ))}
                </Fragment>
              ))}
            </Table.Body>
          </Table.Wrapper>
        </div>
        <hr />
        <div className="w-full flex justify-between items-end px-10 py-4">
          <div className="w-1/2 text-gray-700">
            <h3 className="uppercase text-[10px] tracking-tight leading-tight font-medium ">
              Keterangan Pembayaran
            </h3>
            <p className="text-[10px] tracking-tight leading-tight font-extralight mt-2">
              Untuk melakukan pembayaran, harap transfer ke:
            </p>
            <div className="grid grid-cols-2 text-[10px] tracking-tight leading-tight w-fit gap-y-1 mt-1 pl-2">
              <span className="">Bank:</span>
              <span>BCA</span>
              <span className="">Nama:</span>
              <span>SHIRLEY LOKITO</span>
              <span className="">Rekening:</span>
              <span>8630157189</span>
            </div>
            <p className="text-[10px] tracking-tight leading-tight font-extralight mt-2">
              Setelah melakukan pembayaran, harap mengirimkan bukti pembayaran
              melalui WhatsApp:
              <ul className="pl-2 space-y-1 mt-1">
                <li>
                  <strong>+62 896-1243-6813</strong> (Admin 1)
                </li>
                <li>
                  <strong>+62 813-9202-5016</strong> (Admin 2)
                </li>
                <li>
                  <strong>+62 813-9200-1140</strong> (Admin 3)
                </li>
              </ul>
              .
            </p>
          </div>
          <div className="h-full w-fit grid grid-cols-2 items-center gap-y-1 gap-x-2 text-right">
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Subtotal:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.subtotal(invoice?.customerId)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Ongkir:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.shipmentCost(invoice?.customerId)}
            />
            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Diskon Ongkir:{" "}
            </div>
            <Typography.Currency
              number={-localHelpers.shipmentCostDiscount(invoice?.customerId)}
            />
            {/* <div className="col-span-2 my-3"></div> */}

            <div className="text-xs uppercase text-gray-600 text-right font-light">
              Total:{" "}
            </div>
            <Typography.Currency
              number={localHelpers.total(invoice?.customerId)}
            />
            <div className="col-span-2">
              <hr />
            </div>

            {invoice?.isUseCredit ? (
              <>
                <div className="text-xs uppercase text-right font-light text-primary-600">
                  Kredit Customer:{" "}
                </div>
                <div className="text-primary-600">
                  <Typography.Currency number={invoice?.creditAmount} />
                </div>
              </>
            ) : (
              <></>
            )}

            {invoice?.Payments?.map((payment, key) => (
              <>
                <div
                  className="text-xs uppercase text-primary-600 text-right font-light"
                  key={key}
                >
                  Pembayaran:{" "}
                </div>
                <Typography.Currency number={payment.total_payment} />
              </>
            ))}
            <div className="text-sm uppercase text-gray-600 text-right font-bold">
              Sisa Tagihan:{" "}
            </div>
            <Typography.Currency
              number={
                localHelpers.total(invoice?.customerId) -
                +invoice?.creditAmount -
                localHelpers.payment(invoice?.Payments)
              }
            />
          </div>
        </div>
      </div>
      <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
        <Button onClick={handlePrint} type="submit">
          Print Invoice
        </Button>
      </div>
    </ModalMolecule>
  );
}

export default ViewInvoiceModal;
